var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"persistent":"","value":_vm.isDialogOpen,"width":"450px"}},[_c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$t("global.requiredClient"))+" ")]),_c('v-card-text',[_c('ClientSelector')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }